import React from "react"
import { MdChevronRight } from "react-icons/md"
import styles from "../HotelRoomSelectorV2.module.scss"

interface RoomCardProps {
  name: string
  price: number
  selected: boolean
  onClick: () => void
}

const RoomCard: React.FC<RoomCardProps> = ({ name, price, selected, onClick }) => (
  <button type="button" className={`${styles.roomCard} ${selected ? styles.roomCardSelected : ""}`} onClick={onClick} aria-pressed={selected}>
    <div className={styles.roomName}>{name}</div>
    <div className={styles.roomFooter}>
      <div className={styles.roomPrice}>
        {Math.max(0, Number(price || 0)).toLocaleString("en-US")} <small>VND</small>
      </div>
      <div className={styles.roomArrow}><MdChevronRight size={15} /></div>
    </div>
  </button>
)

export default RoomCard
